<div
  class="tw-flex tw-w-full tw-items-center tw-overflow-hidden tw-rounded-full tw-p-0.5"
  [ngClass]="[sizeClasses.track, colorClass]"
>
  <div
    class="tw-relative tw-h-full tw-rounded-l-full tw-bg-color-surface-card"
    [style.width.%]="emptyPercent"
  >
    <div class="tw-absolute tw-rounded-full" [ngClass]="[sizeClasses.notch, colorClass]"></div>
  </div>
</div>
